import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FieldError } from '../../../elements/field-error/field-error';
import { TextArea } from '../../../elements/text-area';
import dayjs from 'dayjs';
import { Select } from '../../../elements/select';
import { RadioGroup } from '../../../elements/radio-group';
import { Button } from '../../../elements/button';


// construccion del objeto yup de validacion del cuestionario
let obligado = {
    pickup_address: Yup.string().required('obligatorio'),
    pickup_country: Yup.mixed().required('obligatorio'),
    pickup_city: Yup.mixed().required('obligatorio'),
    delivery_address: Yup.string().required('obligatorio'),
    delivery_country: Yup.mixed().required('obligatorio'),
    delivery_city: Yup.mixed().required('obligatorio'),
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    pickup_address: '',
    pickup_country: null,
    pickup_city: '',
    pickup_start_timestamp: null,
    pickup_end_timestamp: null,
    pickup_setup: 0,
    pickup_service: 0,
    pickup_priority: 0,
    delivery_address: '',
    delivery_country: null,
    delivery_city: '',
    delivery_start_timestamp: null,
    delivery_end_timestamp: null,
    delivery_setup: 0,
    delivery_service: 0,
    delivery_priority: 0,
    status: '',
    description: ''
};

export const ShipmentForm = ({
    item,
    isEdit
}: {
    item?: any;
    isEdit: boolean;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };
    const navigate = useNavigate();
    const { api, state, options } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [countries, setCountries] = useState<any | null>([]);
    const [startJobDate, setStartJobDate] = useState<any | null>('1');
    const [startJobDateDelivery, setStartJobDateDelivery] = useState<any | null>('1');

    const estados = [{ id: "PENDING", name: "PENDING" }, { id: "IN_PROGRESS", name: "IN_PROGRESS" }, { id: "COMPLETED", name: "COMPLETED" }]

    const [startingStartTimestamp, setStartingStartTimestamp] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [startingEndTimestamp, setStartingEndTimestamp] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [startingStartTimestampDelivery, setStartingStartTimestampDelivery] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));
    const [startingEndTimestampDelivery, setStartingEndTimestampDelivery] = useState<string>(dayjs().format('YYYY-MM-DDTHH:mm:ss'));

    useEffect(() => {
        api('/fleet/countries/?limit=9999', 'GET');
    }, []);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setStartingStartTimestamp(value);

    };

    const handleChangeEnd = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setStartingEndTimestamp(value);

    };

    const handleChangeDelivery = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setStartingStartTimestampDelivery(value);

    };

    const handleChangeEndDelivery = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        setStartingEndTimestampDelivery(value);

    };

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        console.log('after', after)

        if (after.status && typeof after.status === 'object') {
            after.status = after.status.id;
        }

        if (startJobDate == '2') {
            after.pickup_start_timestamp = startingStartTimestamp;
            after.pickup_end_timestamp = startingStartTimestamp;
        } else if (startJobDate == '3') {
            after.pickup_start_timestamp = startingStartTimestamp;
            after.pickup_end_timestamp = startingEndTimestamp;
        } else {
            after.pickup_start_timestamp = null;
            after.pickup_end_timestamp = null;
        }

        if (startJobDateDelivery == '2') {
            after.delivery_start_timestamp = startingStartTimestampDelivery;
            after.delivery_end_timestamp = startingStartTimestampDelivery;
        } else if (startJobDateDelivery == '3') {
            after.delivery_start_timestamp = startingStartTimestampDelivery;
            after.delivery_end_timestamp = startingEndTimestampDelivery;
        } else {
            after.delivery_start_timestamp = null;
            after.delivery_end_timestamp = null;
        }

        if(+after.pickup_setup > 0) {
            after.pickup_setup = +after.pickup_setup * 60;
        }

        if(+after.pickup_service > 0) {
            after.pickup_service = +after.pickup_service * 60;
        }

        if(+after.delivery_setup > 0) {
            after.delivery_setup = +after.delivery_setup * 60;
        }

        if(+after.delivery_service > 0) {
            after.delivery_service = +after.delivery_service * 60;
        }

        console.log('after', after)

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            // update

            api(`/fleet/shipments/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/shipments/', 'POST', enviaremos);
        }
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('shipments')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    navigate(-1);
                }
            }
            if (state.path.includes('countries')) {
                setCountries(state.data.results);
            }
        }

        if (state.error) {
            if (state.error) {
                if (state.error.non_field_errors[0] == "Could not determine coordinates for the pickup address") {
                    toast.error(`${t('common.label.no-pickup-address')}`);
                }
                if (state.error.non_field_errors[0] == "Could not determine coordinates for the delivery address") {
                    toast.error(`${t('common.label.no-delivery-address')}`);
                }
                if (state.error.non_field_errors[0] == "Error during geocoding. Please check the address and try again.") {
                    toast.error(`${t('common.label.direccion-no-valida')}`);
                }
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">

                    <div className='flex w-full justify-between'>
                        <div className='w-full pt-[5px]'>
                            <Input
                                label={t('common.label.pickup-address')}
                                type="address"
                                placeholder={t('common.label.pickup-address')}
                                name="pickup_address"
                                value={values.pickup_address}
                                onChange={(value) =>
                                    setFieldValue('pickup_address', value.pickup_address)
                                }
                            />
                            <FieldError
                                touched={touched}
                                errors={errors}
                                field={'pickup_address'}
                            />

                        </div>
                        <div className='pl-8 w-full pt-[5px]'>
                            <Input
                                label={t('common.label.pickup-city')}
                                type="text"
                                placeholder={t('common.label.pickup-city')}
                                name="pickup_city"
                                value={values.pickup_city}
                                onChange={(value) =>
                                    setFieldValue('pickup_city', value.pickup_city)
                                }
                            />
                            <FieldError
                                touched={touched}
                                errors={errors}
                                field={'pickup_city'}
                            />
                        </div>
                        <div className='pl-8 w-full'>

                            <Select
                                name="pickup_country"
                                label={t('common.label.pickup-country')}
                                placeholder="Select value"
                                items={countries}
                                value={values.pickup_country}
                                onChange={(value) =>
                                    setFieldValue('pickup_country', value.pickup_country)
                                }
                            />
                            <FieldError
                                touched={touched}
                                errors={errors}
                                field={'pickup_country'}
                            />

                        </div>



                    </div>

                    <div className='flex w-full justify-between py-4'>
                        <div className='w-full pt-[5px]'>
                            <Input
                                label={t('common.label.delivery-address')}
                                type="address"
                                placeholder={t('common.label.delivery-address')}
                                name="delivery_address"
                                value={values.delivery_address}
                                onChange={(value) =>
                                    setFieldValue('delivery_address', value.delivery_address)
                                }
                            />
                            <FieldError
                                touched={touched}
                                errors={errors}
                                field={'delivery_address'}
                            />

                        </div>
                        <div className='pl-8 w-full pt-[5px]'>
                            <Input
                                label={t('common.label.delivery-city')}
                                type="text"
                                placeholder={t('common.label.delivery-city')}
                                name="delivery_city"
                                value={values.delivery_city}
                                onChange={(value) =>
                                    setFieldValue('delivery_city', value.delivery_city)
                                }
                            />
                            <FieldError
                                touched={touched}
                                errors={errors}
                                field={'delivery_city'}
                            />
                        </div>
                        <div className='pl-8 w-full'>

                            <Select
                                name="delivery_country"
                                label={t('common.label.delivery-country')}
                                placeholder="Select value"
                                items={countries}
                                value={values.delivery_country}
                                onChange={(value) =>
                                    setFieldValue('delivery_country', value.delivery_country)
                                }
                            />
                            <FieldError
                                touched={touched}
                                errors={errors}
                                field={'delivery_country'}
                            />

                        </div>



                    </div>

                    <div className='h-8'></div>

                    {/* <DatePicker
                        name="date"
                        type="date"
                        label={t('common.labels.date')}
                        value={values.date}
                        onChange={(val: any) => setFieldValue('date', val.date ? dayjs(val.date).format('YYYY-MM-DD') : null)}
                    />
                    <FieldError touched={touched} errors={errors} field="date" /> */}

                    <RadioGroup
                        name="startJobDate"
                        label={t("")}
                        layout="horizontal"
                        value={startJobDate}
                        items={[
                            { id: '1', label: t('common.label.sin-horario-inicio-pickup') },
                            { id: '2', label: t('common.label.horario-inicio-pickup') },
                            { id: '3', label: t('common.label.franja-horaria-inicio-pickup') },
                        ]}
                        onChange={(newValue) => {
                            setStartJobDate(newValue.startJobDate);
                        }}
                    />

                    {startJobDate == '2' ? <div className="my-[11px] w-full">
                        {/* --------------------FECHA------------------- */}

                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-horario-inicio-servicio-pickup')}
                        </label>
                        <input
                            id="dateInput"
                            type="datetime-local"
                            step="1" // Permite solo minutos (sin segundos)
                            value={startingStartTimestamp} // Mostrar sin segundos en el input
                            onChange={handleChange}
                        />
                    </div> : ''}

                    {startJobDate == '3' ? <div className="my-[11px] w-full">
                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-franja-horaria-inicio-servicio-pickup')}
                        </label>
                        <div>
                            <input
                                id="dateInput"
                                type="datetime-local"
                                step="1" // Permite solo minutos (sin segundos)
                                value={startingStartTimestamp} // Mostrar sin segundos en el input
                                onChange={handleChange}
                            />
                        </div>
                        {/* --------------------FECHA------------------- */}
                        <div className='pt-2'>

                            <input
                                id="dateInput"
                                type="datetime-local"
                                step="1" // Permite solo minutos (sin segundos)
                                value={startingEndTimestamp} // Mostrar sin segundos en el input
                                onChange={handleChangeEnd}
                            />
                        </div>

                    </div> : ''}


                    <div>
                        <TextArea
                            label={t(
                                'common.label.pickup-description'
                            )}
                            placeholder={t(
                                'common.label.pickup-description'
                            )}
                            name="pickup_description"
                            value={values.pickup_description}
                            onChange={(value: any) =>
                                setFieldValue(
                                    'pickup_description',
                                    value.pickup_description
                                )
                            }
                        />
                    </div>

                    <div className='w-full flex justify-between'>
                        <div className='w-full'>
                            <Input
                                label={t('common.label.duracion-pickup-setup')}
                                type="number"
                                placeholder={t('common.label.duracion-pickup-setup')}
                                name="pickup_setup"
                                value={values.pickup_setup}
                                onChange={(value) =>
                                    setFieldValue('pickup_setup', value.pickup_setup)
                                }
                            />
                        </div>
                        <div className='w-full pl-8'>
                            <Input
                                label={t('common.label.duracion-pickup-service')}
                                type="number"
                                placeholder={t('common.label.duracion-pickup-service')}
                                name="pickup_service"
                                value={values.pickup_service}
                                onChange={(value) =>
                                    setFieldValue('pickup_service', value.pickup_service)
                                }
                            />
                        </div>
                    </div>





                    <div className='h-12'></div>

                    <RadioGroup
                        name="startJobDateDelivery"
                        label={t("")}
                        layout="horizontal"
                        value={startJobDateDelivery}
                        items={[
                            { id: '1', label: t('common.label.sin-horario-inicio-delivery') },
                            { id: '2', label: t('common.label.horario-inicio-delivery') },
                            { id: '3', label: t('common.label.franja-horaria-inicio-delivery') },
                        ]}
                        onChange={(newValue) => {
                            setStartJobDateDelivery(newValue.startJobDateDelivery);
                        }}
                    />

                    {startJobDateDelivery == '2' ? <div className="my-[11px] w-full">
                        {/* --------------------FECHA------------------- */}

                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-horario-inicio-servicio-delivery')}
                        </label>
                        <input
                            id="dateInput"
                            type="datetime-local"
                            step="1" // Permite solo minutos (sin segundos)
                            value={startingStartTimestampDelivery} // Mostrar sin segundos en el input
                            onChange={handleChangeDelivery}
                        />
                    </div> : ''}

                    {startJobDateDelivery == '3' ? <div className="my-[11px] w-full">
                        <label className="block text-sm font-semibold leading-6 text-gray-700">
                            {t('common.label.fecha-franja-horaria-inicio-servicio-delivery')}
                        </label>
                        <div>
                            <input
                                id="dateInput"
                                type="datetime-local"
                                step="1" // Permite solo minutos (sin segundos)
                                value={startingStartTimestampDelivery} // Mostrar sin segundos en el input
                                onChange={handleChangeDelivery}
                            />
                        </div>
                        {/* --------------------FECHA------------------- */}
                        <div className='pt-2'>

                            <input
                                id="dateInput"
                                type="datetime-local"
                                step="1" // Permite solo minutos (sin segundos)
                                value={startingEndTimestampDelivery} // Mostrar sin segundos en el input
                                onChange={handleChangeEndDelivery}
                            />
                        </div>

                    </div> : ''}

                    <div>
                        <TextArea
                            label={t(
                                'common.label.delivery-description'
                            )}
                            placeholder={t(
                                'common.label.delivery-description'
                            )}
                            name="delivery_description"
                            value={values.delivery_description}
                            onChange={(value: any) =>
                                setFieldValue(
                                    'delivery_description',
                                    value.delivery_description
                                )
                            }
                        />
                    </div>




                    <div className='w-full flex justify-between'>
                        <div className='w-full'>

                            <Input
                                label={t('common.label.duracion-delivery-setup')}
                                type="number"
                                placeholder={t('common.label.duracion-delivery-setup')}
                                name="delivery_setup"
                                value={values.delivery_setup}
                                onChange={(value) =>
                                    setFieldValue('delivery_setup', value.delivery_setup)
                                }
                            />
                        </div>
                        <div className='w-full pl-8'>
                            <Input
                                label={t('common.label.duracion-delivery-service')}
                                type="number"
                                placeholder={t('common.label.duracion-delivery-service')}
                                name="delivery_service"
                                value={values.delivery_service}
                                onChange={(value) =>
                                    setFieldValue('delivery_service', value.delivery_service)
                                }
                            />
                        </div>
                    </div>

                    <div className='h-12'></div>

                    <div className='w-full flex justify-between'>
                        <div className='w-2/6'>

                            <Select
                                name="status"
                                label={t('common.label.estado')}
                                placeholder="Select value"
                                items={estados}
                                value={data?.status?.id || values.status?.id}
                                onChange={(value) => {
                                    setFieldValue('status', value.status)
                                }

                                }
                            />
                        </div>
                        <div className='w-4/6 pl-8'>
                            <RadioGroup
                                name="priority"
                                label={t("common.label.prioridad")}
                                layout="horizontal"
                                value={values.priority}
                                items={[
                                    { id: '0', label: t('common.label.sin-prioridad') },
                                    { id: '25', label: t('common.label.baja-prioridad') },
                                    { id: '50', label: t('common.label.prioridad-media') },
                                    { id: '75', label: t('common.label.alta-prioridad') },
                                    { id: '100', label: t('common.label.prioridad-muy-alta') }
                                ]}
                                onChange={(newValue) => setFieldValue('priority', newValue.priority)}
                            />
                        </div>
                    </div>
                    <div className='h-8'></div>
                    <div>
                        <Button
                            label={t('common.button.save')}
                            onClick={handleSubmit}
                        />
                    </div>
                </form>
            )}
        </Formik>
    );
};